"use client";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useJobFilterStore } from "../../store/useJobFilterStore";
import { useEffect } from "react";
import { useLanguageStore } from "../../store/useLanguageStore";
import { useCandidateProfileStore } from "../../store/useCandidateProfileStore";

export type Language = {
  languageId: string;
  profiencyId: string;
};

type LanguageField = keyof Language;

type Props = {
  onClose: () => void;
  setLanguage: (data: Language[]) => void;
  defaultData: Language[];
};

export default function EditLanguageForm({
  onClose,
  setLanguage,
  defaultData,
}: Props) {

  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  const { languageSet, proficiencies, fetchFilters } = useJobFilterStore();

  useEffect(() => {
    if (lang) fetchFilters(lang, "languageSet");
    if (lang) fetchFilters(lang, "proficiencies");
  }, [lang]);


  const [languages, setLanguages] = useState<Language[]>(defaultData);

  const handleChange = (i: number, name: LanguageField, value: any) => {
    setLanguages((prev) => {
      const updated = [...prev];
      updated[i] = { ...updated[i], [name]: value };
      return updated;
    });
  };

  const addLanguage = () => {
    setLanguages((prev) => [
      ...prev,
      {
        languageId: "",
        profiencyId: "",
      },
    ]);
  };

  const removeLanguage = (index: number) => {
    setLanguages((prev) => prev.filter((_, i) => i !== index));
  };

  const { updateLanguages, loading } = useLanguageStore();
  const { fetchCandidateProfile } = useCandidateProfileStore();

  const handleSave = async () => {
    const success = await updateLanguages(languages);

    if (success) {
      fetchCandidateProfile();
      setLanguage(languages); // update UI parent
      onClose();
    }
  };

  return (
    <div className="space-y-10 pb-4">
      {languages.map((exp, index) => (
        <div key={index} className="border rounded-xl p-6 space-y-6 relative">
          {languages.length > 1 && (
            <button
              onClick={() => removeLanguage(index)}
              className="absolute top-4 right-4 text-red-500 text-sm font-semibold"
            >
              ✕ {lang === "id" ? "Hapus" : "Remove"}
            </button>
          )}

          <h3 className="text-lg font-semibold">{lang === "id" ? "Bahasa" : "Language"} {index + 1}</h3>

          <div className="space-y-4">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium">{lang === "id" ? "Bahasa" : "Language"}</label>
                <select
                  className="w-full border rounded-lg p-3"
                  value={exp.languageId}
                  onChange={(e) => handleChange(index, "languageId", Number(e.target.value))}
                >
                  <option value="">{lang === "id" ? "Pilih Bahasa" : "Select Language"}</option>
                  {languageSet.map((item: any) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>

              </div>

              <div>
                <label className="text-sm font-medium">{lang === "id" ? "Kemampuan" : "Profiency"}</label>
                <select
                  className="w-full border rounded-lg p-3"
                  value={exp.profiencyId}
                  onChange={(e) => handleChange(index, "profiencyId", Number(e.target.value))}
                >
                  <option value="">{lang === "id" ? "Pilih Kemampuan" : "Select Profiency"}</option>
                  {proficiencies.map((type: any) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </select>

              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="flex justify-center">
        <button
          onClick={addLanguage}
          className="flex items-center gap-2 text-primary font-semibold"
        >
          ➕ {lang === "id" ? "Tambah Bahasa" : "Add Language"}
        </button>
      </div>

      <div className="flex justify-center gap-4 pt-4 pb-2">
        <button
          onClick={onClose}
          className="px-6 py-3 rounded-lg border text-gray-500 font-semibold"
        >
          {lang === "id" ? "Batal" : "Cancel"}
        </button>
        <button
          onClick={handleSave}
          className="px-6 py-3 rounded-lg bg-primary text-white font-semibold"
        >
          {lang === "id" ? "Simpan" : "Save"}
        </button>
      </div>
    </div>
  );
}
